import {deviceData} from "../../dataInterface/deviceDetailInterface";


interface fetchUserReducer {
    type:string
    payload:deviceData
}

export default (state = null, action:fetchUserReducer) => {
    switch (action.type) {
        case "DEVICE_TO_LINK":
            return action.payload;
        default:
            return state;
    }
};
